module.exports = __webpack_public_path__ + "img/Datacleaning.f5e26342.svg";